import React from 'react';
import weddingImage from '../images/IMG_8683.jpg';
import Title from '../Components/Elements/Title';
import Text from '../Components/Elements/Text';
import MainContainer from '../Components/Elements/MainContainer';
import AdaptiveContainer from '../Components/Elements/AdaptiveContainer';
import { Link } from 'react-router-dom';

const Home = () => {
  const todaysDate = new Date().getTime();
  const weddingDate = new Date('2025-09-06').getTime();
  const daysUntilWedding : number = Math.floor((new Date('2025-09-06').getTime() - todaysDate) / (1000 * 60 * 60 * 24)); 
  const areMarried = todaysDate > weddingDate;

  return (
    <MainContainer>
      <AdaptiveContainer className="min-h-[70vh]">
        <div className="flex justify-center items-center max-w-full max-h-full">
          <img 
            src={weddingImage} 
            alt="Wedding" 
            className='w-80 h-80 xs:w-64 xs:h-64 rounded-full object-cover' 
          />
        </div>
        <div className="bg-whit p-4">
          <Title className='text-center py-5' size="3">Hollie and Ryan&apos;s Wedding</Title>
          <Title className='text-center py-5' size="2">September 6, 2025</Title>
          <Title className='text-center py-5' size="2">The Orchard, ME15 8SE</Title>
          {
            !areMarried &&
            <Text className="pt-4">
                <Link
                    to="/app/rsvp"
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold font-lora py-2 px-4 rounded my-6 inline-block text-center"
                >
                    RSVP
                </Link>
            </Text>
          }
          {
            daysUntilWedding > 0 && todaysDate < weddingDate && <Title className='text-center py-5 w-[80%] mx-auto' size="2">Countdown to our special day: {daysUntilWedding} days</Title>
          }
          {
            areMarried && <Title className='text-center py-5 w-[80%] mx-auto' size="2">We got married! Thank you for sharing our special day with us!</Title>
          }
        </div>
      </AdaptiveContainer>
    </MainContainer>
  );
};

export default Home;